import React, {

  useEffect,

  useState,

} from "react";

import { useRestaurantSession } from "../../components/RestaurantSessionProvider";

import {

  useCart,

} from "../../components/CartContext"

import {

  useDispatch,

  useSelector,

} from "react-redux";

import {

  useNavigate,

  useParams,

} from "react-router-dom";

import {

  createRazorpayOrder,

  verifyRazorpayPayment,

  resetPayment,

} from "../../actions/paymentActions";

import "./css/PaymentScreen.css";

function PaymentScreen() {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { sessionToken } = useRestaurantSession();

  // =====================================================

  // CART

  // =====================================================

  const {

    clearCart,

  } = useCart();

  // =====================================================

  // URL PARAMS

  // =====================================================

  const {

    restaurantId,

    tableId,

  } = useParams();

  // =====================================================

  // REDUX - ORDER

  // =====================================================

  const {

    order,

  } = useSelector(

    (state) => state.order

  );

  // =====================================================

  // REDUX - PAYMENT

  // =====================================================

  const {

    loading,

    error,

  } = useSelector(

    (state) => state.payment

  );

  // =====================================================

  // DEBUG

  // =====================================================

  console.log(

    "PAYMENT SCREEN:",

    {

      loading,

      error,

      order,

    }

  );

  // =====================================================

  // LOCAL STATE

  // =====================================================

  const [

    paymentStarted,

    setPaymentStarted

  ] = useState(false);

  // =====================================================

  // CHECK ORDER

  // =====================================================

  useEffect(() => {

    if (!order) {

      navigate(

        `/${restaurantId}/table/${tableId}/checkout`

      );

    }

  }, [

    order,

    navigate,

    restaurantId,

    tableId,

  ]);

  // =====================================================

  // RESET PAYMENT STATE

  // =====================================================

  useEffect(() => {

    dispatch(

      resetPayment()

    );

  }, [

    dispatch,

  ]);

  // =====================================================

  // LOAD RAZORPAY

  // =====================================================

  useEffect(() => {

    if (

      document.querySelector(

        'script[src="https\://checkout.razorpay.com/v1/checkout.js"]'

      )

    ) {

      return;

    }

    const script =

      document.createElement("script");

    script.src =

      "https\://checkout.razorpay.com/v1/checkout.js";

    script.async = true;

    document.body.appendChild(

      script

    );

    return () => {

      // Do not remove the script.

      // Razorpay can remain loaded.

    };

  }, []);

// =====================================================

  // START RAZORPAY PAYMENT

  // =====================================================

  const handlePayment = async () => {

    if (!order) {

      return;

    }

    // ---------------------------------------------------

    // CHECK RAZORPAY

    // ---------------------------------------------------

    if (

      !window.Razorpay

    ) {

      console.error(

        "Razorpay SDK is not loaded."

      );

      return;

    }

    try {

      setPaymentStarted(

        true

      );

      // =================================================

      // CREATE RAZORPAY ORDER

      // =================================================

      console.log(

        "CREATING RAZORPAY ORDER..."

      );

      const razorpayData =

        await dispatch(

          createRazorpayOrder(

            restaurantId,

            order.id,

            sessionToken

          )

        );

      console.log(

        "Razorpay order:",

        razorpayData

      );

      // =================================================

      // RAZORPAY OPTIONS

      // =================================================

      const options = {

        key:

          razorpayData.key_id,

        amount:

          razorpayData.amount,

        currency:

          razorpayData.currency,

        name:

          "TASTY BITE",

        description:

          `Order #${order.order_number}`,

        order_id:

          razorpayData.razorpay_order_id,

        // ===============================================

        // SUCCESS

        // ===============================================

        handler:

          async function (response) {

            console.log(

              "Razorpay payment response:",

              response

            );

            try {

              console.log(

                "VERIFYING RAZORPAY PAYMENT..."

              );

              await dispatch(

                verifyRazorpayPayment(

                  restaurantId,

                  {

                    order_id:

                      order.id,

                    razorpay_order_id:

                      response.razorpay_order_id,

                    razorpay_payment_id:

                      response.razorpay_payment_id,

                    razorpay_signature:

                      response.razorpay_signature,

                  },

                  sessionToken

                )

              );

              // ------------------------------------------------

              // Payment successfully verified

              // ------------------------------------------------

              console.log(

                "PAYMENT VERIFIED - CLEARING CART"

              );

              clearCart();

              // Navigate only after verification for this order succeeds.
              navigate(`/${restaurantId}/table/${tableId}/success`, { replace: true });

            } catch (error) {

              console.error(

                "Payment verification failed:",

                error

              );

              setPaymentStarted(

                false

              );

            }

          },

        // ===============================================

        // PREFILL

        // ===============================================

        modal: {
          ondismiss: () => setPaymentStarted(false),
        },

        prefill: {

          name:

            "",

          email:

            "",

          contact:

            "",

        },

        // ===============================================

        // THEME

        // ===============================================

        theme: {

          color:

            "#000000",

        },

      };

      // =================================================

      // OPEN RAZORPAY

      // =================================================

      console.log(

        "OPENING RAZORPAY..."

      );

      const razorpay =

        new window.Razorpay(

          options

        );

      // =================================================

      // PAYMENT FAILED

      // =================================================

      razorpay.on(

        "payment.failed",

        function (response) {

          console.error(

            "Payment failed:",

            response

          );

          setPaymentStarted(

            false

          );

        }

      );

      razorpay.open();

    } catch (error) {

      console.error(

        "Payment initialization failed:",

        error

      );

      setPaymentStarted(

        false

      );

    }

  };

  // =====================================================

  // NO ORDER

  // =====================================================

  if (!order) {

    return null;

  }

  // =====================================================

  // PAGE

  // =====================================================

  return (

    <div className="payment-page">

      <div className="payment-container">

        {/* HEADER */}

        <div className="payment-header">

          <h1>

            Payment

          </h1>

          <p>

            Complete your payment

          </p>

        </div>

        {/* ERROR */}

        {error && (

          <div className="payment-error">

            {typeof error === "string"

              ? error

              : "Payment failed"}

          </div>

        )}

        {/* ORDER */}

        <div className="payment-order-card">

          <div>

            <span>

              Order Number

            </span>

            <strong>

              #{order.order_number}

            </strong>

          </div>

          <div>

            <span>

              Total Amount

            </span>

            <strong>

              ₹

              {Number(

                order.total

              ).toFixed(2)}

            </strong>

          </div>

        </div>

        {/* PAYMENT */}

        <div className="payment-card">

          <h2>

            Online Payment

          </h2>

          <p>

            You will be redirected to

            Razorpay to complete your payment.

          </p>

          <button

            type="button"

            className="pay-now-button"

            onClick={handlePayment}

            disabled={

              loading ||

              paymentStarted

            }

          >

            {loading ||

            paymentStarted

              ? "Opening Payment..."

              : `Pay ₹${Number(

                  order.total

                ).toFixed(2)}`}

          </button>

        </div>

        {/* BACK */}

        <button

          type="button"

          className="payment-back-button"

          onClick={() =>

            navigate(

              `/${restaurantId}/table/${tableId}/order`

            )

          }

        >

          ← Back to Order

        </button>

      </div>

    </div>

  );

}

export default PaymentScreen;